import { gql } from 'graphql-request'

import { UserListRow } from '@/types/User'

import { TicketQueries } from './ticket.queries'

export namespace UserQueries {
  export const QUERY_KEYS = {
    getMember: 'getMember',
    getMembers: 'getMembers',
    getMissionControlUsers: 'getMissionControlUsers',
    getSearchOwner: 'getSearchOwner',
  }

  export namespace GET_MEMBERS {
    export type Response = { members: UserListRow[] | null }
  }

  export namespace GET_INTERNAL_USERS {
    export type Response = {
      authorizedUsers:
        | {
            fullName?: string
            id: number
          }[]
        | null
    }
  }

  export function getMember() {
    return gql`
      query getMember($id: Int!) {
        member(id: $id) {
          id
          fullName
          email
          role
          phone
          dateOfBirth
          notes
          tickets(filter: {}) {
            ...TimelineTickets
          }
          reservations {
            id
            cancelledAt
            moveInDate
            moveOutDate
            monthlyRent
            nightlyRate
            flightxInProgress
            lexit
            status
            home {
              id
              homeQualityStatus
              searchDocument
            }
          }
          active
          stayCommitments {
            committedNights
            earlyTerminationFeeType
            fulfilledAt
            earlyTerminationFeeWaivedAt
            cancelledAt
            createdAt
          }
          appeasements {
            amount
            reason
            category
            motivation
            team
            status
            createdAt
          }
        }
      }
      ${TicketQueries.TIMELINE_TICKETS}
    `
  }

  export function getMembers() {
    return gql`
      query getSearchedMember($search: String) {
        members(filter: { limit: 20, search: $search }) {
          id
          fullName
          email
          role
          phone
        }
      }
    `
  }
  export function getHostsBySearch() {
    return gql`
      query hostSelectionUsers($searchString: String) {
        hostSelectionUsers(searchString: $searchString) {
          fullName
          id
        }
      }
    `
  }

  export function getSearchedMember() {
    return gql`
      query getSearchedMember($searchString: String) {
        members(filter: { limit: 20, search: $searchString }) {
          fullName
          id
        }
      }
    `
  }

  export function getSearchOwner() {
    return gql`
      query getSearchOwner($searchString: String) {
        authorizedUsers(
          filter: { limit: 20, searchString: $searchString, roles: [agm, hubmanager, admin, superadmin] }
        ) {
          fullName
          id
        }
      }
    `
  }

  export function getSearchInternalUser() {
    return gql`
      query getSearchOwner($searchString: String) {
        authorizedUsers(
          filter: {
            limit: 20
            searchString: $searchString
            adminPermissionSet: [newmemberteamgeneralmanager, newmemberteamsalesspecialist]
          }
        ) {
          fullName
          id
        }
      }
    `
  }

  export function getMissionControlUsers() {
    return gql`
      query getSearchOwner($limit: Int!) {
        authorizedUsers(filter: { limit: $limit, roles: [agm, hubmanager, admin, superadmin] }) {
          fullName
          id
        }
      }
    `
  }
}
